import { useTheme as muiUseTheme } from '@mui/material/styles';
import { AppTheme } from '../theme/model';

export const useTheme = muiUseTheme as () => AppTheme;
